/**
 * Mixin for contact list navigation functionality
 * Provides navigation between contacts in sent/received lists
 */
export default {
  computed: {
    contactList() {
      // Determine which contact list to use based on prop, route, or available data
      let listType = this.contactListType;
      
      // Auto-detect from route if prop not provided
      if (!listType && this.$route) {
        if (this.$route.path.includes('/received-list')) {
          listType = 'received';
        } else if (this.$route.path.includes('/sent-list')) {
          listType = 'sent';
        }
      }
      
      // Use the appropriate list based on type
      if (listType === 'received') {
        return this.receivedContacts && this.receivedContacts.length > 0 
          ? this.receivedContacts 
          : [];
      } else if (listType === 'sent') {
        return this.sentContacts && this.sentContacts.length > 0 
          ? this.sentContacts 
          : [];
      }
      
      // Fallback: if both lists exist, prefer received (for backward compatibility)
      if (this.receivedContacts && this.receivedContacts.length > 0) {
        return this.receivedContacts;
      }
      if (this.sentContacts && this.sentContacts.length > 0) {
        return this.sentContacts;
      }
      return [];
    },
    contactApplicants() {
      // Extract applicants from contacts
      // Contact receiver has _id field
      return this.contactList.map(contact => {
        const receiver = contact.receiver || contact;
        return {
          _id: receiver._id,
          id: receiver._id, // Also set id for compatibility
          ...receiver
        };
      });
    },
    navigationList() {
      // Use contact list if available, otherwise fall back to applicants
      return this.contactApplicants.length > 0 ? this.contactApplicants : this.applicants;
    },
    canGoPrevious() {
      return this.index > 0;
    },
    canGoNext() {
      return this.index < this.navigationList.length - 1;
    },
  },
  methods: {
    updateIndexFromApplicantId() {
      // Find index in navigation list based on applicantId
      if (this.navigationList.length > 0 && this.applicantId) {
        const foundIndex = this.navigationList.findIndex(
          applicant => {
            const applicantId = applicant._id || applicant.id;
            return applicantId === this.applicantId || applicantId === this.applicant_id;
          }
        );
        if (foundIndex !== -1) {
          this.index = foundIndex;
        } else if (this.applicantIndex !== undefined) {
          // Fall back to prop if provided
          this.index = this.applicantIndex;
        }
      } else if (this.applicantIndex !== undefined) {
        this.index = this.applicantIndex;
      }
    },
    changeApplicant(index) {
      if (this.navigationList[index]) {
        const applicant = this.navigationList[index];
        // Contact list uses _id, applicants list might use id
        const newApplicantId = applicant._id || applicant.id;
        
        // Only update if it's a different applicant
        if (newApplicantId && newApplicantId !== this.applicantId) {
          // Update applicantId first
          this.applicantId = newApplicantId;
          this.index = index;
          if (this.currentApplicantJd) {
            this.applicantJd = this.currentApplicantJd;
          }
          this.$emit('changeIndex', index);
          // Call loadApplicantData if it exists in the component
          if (typeof this.loadApplicantData === 'function') {
            this.loadApplicantData(newApplicantId);
          }
        }
      }
    },
    previous() {
      const index = this.index - 1;
      if (index >= 0 && this.navigationList[index]) {
        this.changeApplicant(index);
      }
    },
    next() {
      const index = this.index + 1;
      if (index < this.navigationList.length && this.navigationList[index]) {
        this.changeApplicant(index);
      }
    },
    handlePrevious() {
      this.previous();
    },
    handleNext() {
      this.next();
    },
  },
};

